module.exports = __webpack_public_path__ + "img/26.1.06e9d9e3.jpg";